import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { StyledAccessibilityAnnouncer } from './AccessibilityAnnouncer.styled';

const AccessibilityAnnouncer: React.FC<
  {
    isLoading?: boolean;
    route?: string;
    customAnnouncementIntlKey?: string;
  } & {
    intl: IntlShape;
  }
> = ({
  isLoading,
  route,
  customAnnouncementIntlKey,
  intl: { formatMessage },
}) => {
  const [announcement, setAnnouncement] = useState<string | undefined>(
    undefined,
  );

  // set loading announcement
  useEffect(() => {
    if (isLoading) {
      setAnnouncement(`message.announcer.${isLoading}`);
      setTimeout(() => setAnnouncement(undefined), 300);
    }
  }, [isLoading]);

  // set page changed announcement
  useEffect(() => {
    if (route) {
      setAnnouncement(`message.announcer.routeChanged.${route}`);
      setTimeout(() => setAnnouncement(undefined), 300);
    }
  }, [route]);

  // set custom announcement
  useEffect(() => {
    if (customAnnouncementIntlKey) {
      setAnnouncement(customAnnouncementIntlKey);
      setTimeout(() => setAnnouncement(undefined), 300);
    }
  }, [customAnnouncementIntlKey]);

  return (
    <StyledAccessibilityAnnouncer role="status" aria-live="polite">
      {announcement && formatMessage({ id: announcement })}
    </StyledAccessibilityAnnouncer>
  );
};

export default injectIntl(AccessibilityAnnouncer);
